function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 20h-15A2.5 2.5 0 010 17.5v-15A2.5 2.5 0 012.5 0h15A2.5 2.5 0 0120 2.5v15a2.5 2.5 0 01-2.5 2.5z",
  fill: "#1D9BF0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.68 15.08c4.715 0 7.295-3.91 7.295-7.295 0-.11 0-.22-.005-.33.5-.36.935-.815 1.28-1.33-.46.205-.955.34-1.475.405a2.58 2.58 0 001.13-1.42 5.1 5.1 0 01-1.63.62 2.56 2.56 0 00-1.87-.81 2.567 2.567 0 00-2.5 3.15A7.28 7.28 0 014.62 5.39a2.57 2.57 0 00.795 3.425 2.593 2.593 0 01-1.16-.32v.035c0 1.24.885 2.28 2.055 2.515a2.5 2.5 0 01-.675.09 2.52 2.52 0 01-.48-.045 2.564 2.564 0 002.395 1.78 5.142 5.142 0 01-3.795 1.065A7.293 7.293 0 007.68 15.08z",
  fill: "#fff"
});

function SvgSocialTwitter(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

SvgSocialTwitter.defaultProps = {
  color: "#000",
  title: "Social Twitter"
};
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJyZWFjdC1jb21wb25lbnRzL2ljb25zL1NvY2lhbFR3aXR0ZXItNmM3OGQ1ZTEyZDJmNmQ2MDRkNDAxYzE5MTc3ZDM2ODUuc3ZnIjs=";
export { SvgSocialTwitter as ReactComponent };